"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetStudyCodingDownloadUrlResponse = exports.DeleteStudyCodingResponse = exports.MigrateStudyCodingResponse = exports.CheckStudyCodingsMigratableResponse = exports.StudyFastCodingResponse = exports.UpdateStudyCodingAttrsResponse = exports.StudyAutoCodingResponse = exports.UpdateStudyCodingResponse = exports.GetStudyCodingResponse = exports.CreateStudyCodingResponse = void 0;
class CreateStudyCodingResponse {
}
exports.CreateStudyCodingResponse = CreateStudyCodingResponse;
class GetStudyCodingResponse {
}
exports.GetStudyCodingResponse = GetStudyCodingResponse;
class UpdateStudyCodingResponse {
}
exports.UpdateStudyCodingResponse = UpdateStudyCodingResponse;
class StudyAutoCodingResponse {
}
exports.StudyAutoCodingResponse = StudyAutoCodingResponse;
class UpdateStudyCodingAttrsResponse {
}
exports.UpdateStudyCodingAttrsResponse = UpdateStudyCodingAttrsResponse;
class StudyFastCodingResponse {
}
exports.StudyFastCodingResponse = StudyFastCodingResponse;
class CheckStudyCodingsMigratableResponse {
}
exports.CheckStudyCodingsMigratableResponse = CheckStudyCodingsMigratableResponse;
class MigrateStudyCodingResponse {
}
exports.MigrateStudyCodingResponse = MigrateStudyCodingResponse;
class DeleteStudyCodingResponse {
}
exports.DeleteStudyCodingResponse = DeleteStudyCodingResponse;
class GetStudyCodingDownloadUrlResponse {
}
exports.GetStudyCodingDownloadUrlResponse = GetStudyCodingDownloadUrlResponse;
//# sourceMappingURL=studyCoding.js.map